import { render } from "./ContextMenu.vue?vue&type=template&id=f9312e22&scoped=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=f9312e22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9312e22"

export default script